export const CarSvg = () => {
    return (
      <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.92 9.5C18.7783 9.19581 18.6066 8.90331 18.4066 8.63L16.06 5.63C15.7598 5.23109 15.3919 4.88823 14.9734 4.62058C14.5549 4.35293 14.0935 4.16476 13.61 4.07L12.12 3.75H11.85L10.36 4.07C9.87653 4.16476 9.41508 4.35293 8.99659 4.62058C8.57811 4.88823 8.21018 5.23109 7.91 5.63L5.56 8.63C5.36003 8.90331 5.18834 9.19581 5.05 9.5L3 10V17H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H8C8.53043 21 9.03914 20.7893 9.41421 20.4142C9.78929 20.0391 10 19.5304 10 19V17H14V19C14 19.5304 14.2107 20.0391 14.5858 20.4142C14.9609 20.7893 15.4696 21 16 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V17H21V10L18.92 9.5ZM6.3 10L8.23 7.15C8.42296 6.91229 8.66328 6.71685 8.93548 6.57726C9.20768 6.43767 9.50472 6.35751 9.81 6.34L12 6L14.2 6.34C14.5053 6.35751 14.8023 6.43767 15.0745 6.57726C15.3467 6.71685 15.587 6.91229 15.78 7.15L17.7 10H6.3Z"
          fill="currentColor"
        />
        <path
          d="M7 14C7 14.5523 6.55228 15 6 15C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13C6.55228 13 7 13.4477 7 14Z"
          fill="currentColor"
        />
        <path
          d="M19 14C19 14.5523 18.5523 15 18 15C17.4477 15 17 14.5523 17 14C17 13.4477 17.4477 13 18 13C18.5523 13 19 13.4477 19 14Z"
          fill="currentColor"
        />
      </svg>
    );
  };